module.exports = __webpack_public_path__ + "img/19.4230c17d.png";